module.exports = __webpack_public_path__ + "img/Infection_Outbreak_Alpha.4959331c.jpg";